import { makeStyles } from 'tss-react/mui'
import _colors from 'styles/global/_colors'

export const useStyles = makeStyles()((theme) => ({
  mainContainer: {
    padding: '24px',
    [theme.breakpoints.down('md')]: {
      padding: '20px',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '16px',
    },
    [theme.breakpoints.down('xs')]: {
      padding: '12px',
    },
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '80vh',
    marginTop: '20px',
    padding: '24px',
    borderRadius: '4px',
    boxShadow: '0 1px 5px rgba(0,0,0,.12),0 1px 4px rgba(0,0,0,.24)',
    [theme.breakpoints.down('md')]: {
      padding: '20px',
      marginTop: '16px',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '16px',
      marginTop: '12px',
    },
    [theme.breakpoints.down('xs')]: {
      padding: '12px',
      marginTop: '8px',
    },
  },
  title: {
    color: _colors.blue,
    fontSize: '20px',
    fontWeight: '400',
    lineHeight: '150%',
    letterSpacing: '0.15px',
    marginBottom: '25px',
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    gap: '24px',
    marginBottom: '24px',
    [theme.breakpoints.down('lg')]: {
      height: 'auto',
      flexWrap: 'wrap',
      gap: '16px',
      justifyContent: 'space-between',
    },
  },
  tabsContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '20px',
    [theme.breakpoints.down('md')]: {
      flex: '1',
    },
    [theme.breakpoints.down(630)]: {
      flex: '1 0 100%',
    },
  },
  dataPointsLabel: {
    color: _colors.blue,
    fontSize: '16px',
    lineHeight: '143%',
    letterSpacing: '0.15px',
    whiteSpace: 'nowrap',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  actionsContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '16px',
    marginTop: '24px',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'space-between',
    },
  },
  actionBtn: {
    minWidth: '150px',
    padding: '8px 16px',
    [theme.breakpoints.down('sm')]: {
      flex: '1',
      fontSize: '14px',
      minWidth: 'unset',
    },
  },
  resetBtn: {
    minWidth: '95px',
    padding: '8px 16px',
    marginLeft: 'auto',
    [theme.breakpoints.down('sm')]: {
      fontSize: '13px',
    },
  },
  filteringButton: {
    minWidth: '130px',
    height: '40px',
    fontSize: '15px',
    fontWeight: 400,
    fontFamily: 'HP Simplified',
    color: _colors.blue,
    border: `2px solid ${_colors.blue}`,
    borderRadius: '20px',
    padding: '4px 16px',
    textTransform: 'none' as const,
    backgroundColor: '#ffffff',
    '&:hover': {
      backgroundColor: _colors.blueBgHover,
      borderColor: _colors.blue,
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px',
      padding: '4px 8px',
      height: '34px',
    },
  },
  filteringDropdownPaper: {
    minWidth: '140px',
    borderRadius: '4px',
    overflow: 'hidden',
  },
  filteringMenuItem: {
    fontSize: '14px',
    color: '#56585a',
    padding: '8px 16px',
    '&:hover': {
      backgroundColor: _colors.blueBgHover,
    },
    '&.Mui-selected': {
      backgroundColor: _colors.blueBgSelect,
      color: _colors.blue,
    },
  },
}))
